interface Props {
  size?: number;
  color?: string;
}

const UploadIcon = (props: Props) => {
  const { color = '#000', size = 30 } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8877 21.5637H9.8877C7.05927 21.5637 5.64506 21.5637 4.76638 20.685C3.8877 19.8063 3.8877 18.3921 3.8877 15.5637M21.8877 15.5637C21.8877 18.3921 21.8877 19.8063 21.009 20.685C20.7092 20.9848 20.3471 21.1823 19.8877 21.3124"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8877 16.5637V3.56372M12.8877 3.56372L16.8877 7.93872M12.8877 3.56372L8.8877 7.93872"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UploadIcon;
